module.exports = __webpack_public_path__ + "static/media/boltbox_logo.8d526cda.png";